var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 124,
    viewBox: "0 0 120 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.01 46.0821C107.122 46.0821 108.835 44.3683 108.835 42.2541C108.835 40.14 107.122 38.4261 105.01 38.4261C102.898 38.4261 101.186 40.14 101.186 42.2541C101.186 44.3683 102.898 46.0821 105.01 46.0821Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41657 66.7833C4.80621 66.7833 5.93274 65.6557 5.93274 64.2649C5.93274 62.874 4.80621 61.7464 3.41657 61.7464C2.02692 61.7464 0.900391 62.874 0.900391 64.2649C0.900391 65.6557 2.02692 66.7833 3.41657 66.7833Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.983 112.06C16.3726 112.06 17.4991 110.932 17.4991 109.541C17.4991 108.151 16.3726 107.023 14.983 107.023C13.5933 107.023 12.4668 108.151 12.4668 109.541C12.4668 110.932 13.5933 112.06 14.983 112.06Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4329 112.06L63.7419 100.996V55.6344L28.4329 66.6131V112.06Z",
    fill: "#B7BFCD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M99.0508 112.06L63.7418 100.996V55.6344L99.0508 66.6131V112.06Z",
    fill: "#6D7C9A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4329 112.06L63.7419 100.996V55.6344L28.4329 66.6131V112.06Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0508 112.06L63.7419 100.996V55.6344L99.0508 66.6131V112.06Z",
    fill: "url(#paint1_linear)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7419 123.209L28.4329 112.145V66.7833L63.7419 77.8471V123.209Z",
    fill: "#EDF1F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7418 123.209L99.0508 112.145V66.7833L63.7418 77.8471V123.209Z",
    fill: "#DAE1ED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M55.7419 115.209L28.4329 112.145V66.7833L63.7419 77.8471L55.7419 115.209Z",
    fill: "url(#paint2_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M71.7418 107.209L99.0508 112.145V66.7833L63.7418 77.8471L71.7418 107.209Z",
    fill: "url(#paint3_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7418 55.6344L47.1407 43.2088L11.2418 55.2939L28.4328 66.6131L63.7418 55.6344Z",
    fill: "#DAE1ED"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7418 55.6344L80.3429 43.2088L116.242 55.2939L99.0508 66.6131L63.7418 55.6344Z",
    fill: "#DAE1ED"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4328 66.7833L63.7418 77.8471L46.1295 89.0812L11.2418 77.5067L28.4328 66.7833Z",
    fill: "#EFF4FD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0508 66.7833L63.7418 77.8471L81.3542 89.0812L116.242 77.5067L99.0508 66.7833Z",
    fill: "#EDF1F9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5933 12.0856C78.5399 25.5101 80.0143 28.4929 80.4982 41.7208C80.3121 44.7403 80.1967 48.0237 78.7732 50.6675C76.8721 54.712 72.222 57.5129 67.8287 57.5583C63.3028 57.6392 58.8657 54.8681 56.8685 50.595C55.4634 48.0016 55.5081 44.4544 57.4355 42.0998C59.5308 39.8417 63.217 39.2786 65.8687 40.6896C68.7856 42.0295 70.5266 44.8157 71.1715 47.7541C71.8163 50.6924 71.533 53.8794 70.7459 56.777C69.0996 63.8245 67.7361 64.1654 63.6988 76.0972",
    stroke: "#ABB5CC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6136 4.98004C79.6021 6.95402 77.7651 8.16271 75.4356 7.53242C72.9829 7.11431 71.2469 6.68339 71.1352 4.92159C71.1914 3.11479 73.1627 2.40764 75.4701 1.6105C78.2366 0.511175 79.4571 3.05106 79.6136 4.98004Z",
    fill: "#DAE2EB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7646 11.0164C65.0076 12.296 67.6283 12.6692 68.9054 10.7146C70.3058 8.54779 71.5044 6.97255 70.2166 5.52573C68.9736 4.2461 67.7638 5.10762 64.9973 6.20694C62.7795 7.33845 62.3088 9.61459 63.7646 11.0164Z",
    fill: "#DAE2EB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5002 2.85108C70.6315 2.36892 71.9867 2.72265 72.5914 3.63574C72.8489 3.9251 73.1512 4.38165 73.2408 4.71601C74.2037 6.96654 73.9009 9.19769 72.6017 9.72485C71.1792 10.4642 69.2193 9.19736 68.4692 7.06902C68.2901 6.4003 68.2006 6.06594 68.0662 5.56439C67.9208 4.34913 68.369 3.33324 69.5002 2.85108C69.6682 2.80608 69.5002 2.85108 69.5002 2.85108Z",
    fill: "#989FB0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4991 39.0791H15.309V36.889H13.4319V39.0791H11.2418V41.0188H13.4319V43.2088H15.309V41.0188H17.4991V39.0791Z",
    fill: "url(#paint4_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3098 94.0262H20.1197V91.8362H18.2425V94.0262H16.0525V95.9659H18.2425V98.156H20.1197V95.9659H22.3098V94.0262Z",
    fill: "url(#paint5_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M118.048 94.1502L115.368 92.7973L116.721 90.1178L114.424 88.9582L113.071 91.6377L110.392 90.2849L109.193 92.6582L111.873 94.0111L110.52 96.6906L112.817 97.8502L114.17 95.1706L116.849 96.5235L118.048 94.1502Z",
    fill: "url(#paint6_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 52.5956,
    y1: 58.9197,
    x2: 47.7796,
    y2: 78.9695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 52.5956,
    y1: 58.9197,
    x2: 47.7796,
    y2: 78.9695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 36.3489,
    y1: 97.8286,
    x2: 44.8315,
    y2: 73.8705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#6C80AA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D6A86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 82.7976,
    y1: 104.373,
    x2: 83.4647,
    y2: 73.9704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#314F91",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#324264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 14.3709,
    y1: 37.1086,
    x2: 14.3709,
    y2: 40.6558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 19.1816,
    y1: 92.0557,
    x2: 19.1816,
    y2: 95.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 115.437,
    y1: 89.8069,
    x2: 113.246,
    y2: 94.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/emptyBox.5f853be71764efc1e21417387821ad55.svg";
export { ForwardRef as ReactComponent };